module.exports = __webpack_public_path__ + "static/img/wxkefu.f0cea4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/wxkefu.png
// module id = prDz
// module chunks = 29